<template>
  <div class="floralTutorial">
    <div class="container">
      <h1>花藝課程影片</h1>
      <div class="row" v-if="videoArr.length === 0">
        <div class="col-3 pb-5" v-for="(item) in 4"
        :key="item">
          <v-skeleton-loader
            width="100%"
            type="list-item-avatar, image"
          ></v-skeleton-loader>
        </div>
      </div>
      <div class="row" v-if="videoArr.length > 0">
        <div class="col-3 pb-5"
        v-for="(item, index) in videoArr"
        :key="index">
          <iframe
          :src='`https://www.youtube.com/embed/${item.id.videoId}`'
          frameborder="0"
          width="100%">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoArr: [],
    };
  },
  methods: {
    /* eslint-disable */
    getYoutubeVideos() {
      const vm = this;
      return gapi.client.youtube.search.list({
        "part": [
          "snippet"
        ],
        "maxResults": 12,
        "q": "花藝"
      })
        .then(function (response) {
          const videoArr = response.result.items;
          vm.videoArr = videoArr;
        },
          function (err) { console.error("Execute error", err); });
    },
    initializeYoutubeApi() {
      const vm = this;
      const YOUR_API_KEY = 'AIzaSyDwBeVT0Nvdb9PSLUYG2wM7nuMYnQzj5Q8';
      const YOUR_CLIENT_ID = '504820109725-r45b35p3vqrisoksf5rkqeh178odpgj1.apps.googleusercontent.com';
      function authenticate() {
        return gapi.auth2.getAuthInstance()
          .signIn({ scope: "https://www.googleapis.com/auth/youtube.force-ssl" })
          .then(function () { console.log("Sign-in successful"); },
            function (err) { console.error("Error signing in", err); });
      }
      function loadClient() {
        gapi.client.setApiKey(YOUR_API_KEY);
        return gapi.client.load("https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest")
          .then(function () { console.log("GAPI client loaded for API"); vm.getYoutubeVideos(); },
            function (err) { console.error("Error loading GAPI client for API", err); });
      }

      gapi.load("client:auth2", function () {
        gapi.auth2.init({ client_id: YOUR_CLIENT_ID });
        authenticate().then(loadClient)
      });
    },
    /* eslint-enable */
  },
  created() {
    this.initializeYoutubeApi();
  },
};
</script>
